/* eslint-disable no-console */
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import './plugins/apm';
import router from './router'
import api from './api'
import vSelect from 'vue-select'
import VueSweetalert2 from 'vue-sweetalert2';
import store from './store'
import Vuex from 'vuex'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import isNull from "lodash/isNull";
import get from "lodash/get";

import './plugins/tiptap-vuetify'

const options = {
  textColor: '#41b882',
};
Vue.config.productionTip = false
Vue.prototype.$http = api
Vue.config.devtools = true;
Vue.use(VueSweetalert2, options);

const qs = require('qs')

sync(store, router)

if(process.env.VUE_APP_SENTRY_ENABLE === '1') {
  Sentry.init({
    Vue,
    dsn: "https://a8a559b41b976cb26e1426088b8eee9f@sentry-au.devtools.sbs/11",
    // Every build that enables Sentry shares one DSN, so without this the dev
    // deploys report as production and their events are indistinguishable from
    // real user traffic. Defaults to production so existing builds are unchanged.
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          "localhost:8080",
          "city-councils-dev.street-directory.com.au",
          "local-government.street-directory.com.au",
          "hawk-gps.street-directory.com.au",
          /^\//
        ],
      }),
    ],
    tracesSampleRate: 0.25,
  });
}

const STORAGE_NAME = `carpool_${process.env.VUE_APP_WEB}`;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const userType = get(store, 'state.user.user.type', null);
    if (userType != null) {
      if (to.matched.some(record => record.meta.allowedRoles)) {
        const allowedRoles = to.meta.allowedRoles;
        if (!allowedRoles.includes(parseInt(userType))) {
          next('/unauthorized');
          return;
        }
      }
    }
  }

  const toRoute = to.path.split('/').filter(t => t !== '');
  if (toRoute[0] === 'register') {
    return api.post(`${process.env.VUE_APP_API_URL}/validate_hash`, qs.stringify({ hash: toRoute[1] }))
      .then((response) => {
        if (get(response, 'data.data.valid')) {
          next()
        } else {
          next('/login')
        }
      })
      // validate_hash answers 500 on a bad hash. Every path out of a guard has
      // to reach next(), or the router simply stops.
      .catch(() => next('/login'))
  }

  if (store.state.token) {
    if (toRoute[0] === 'message') return next(from.path);
    // check_token answers 401 for a dead session. That used to arrive as a
    // resolved response carrying the code in its body; once resp_json sets a
    // real HTTP status it arrives as a rejection instead. Both land here.
    const onTokenRejected = () => {
      new Promise((resolve, reject) => {
        try {
          localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
        } catch (e) {}
        resolve();
      })
      .then(
        () => {
          store.commit('ERROR_STATUS', false)
          store.commit('REMOVE_DATA')
        }
      )
      if (process.env.VUE_APP_SSO) {
        if (process.env.VUE_APP_WEB === 'yarra') {
          window.location.href = process.env.VUE_APP_SSO;
          return;
        } else {
          if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
            const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
            window.location.href = `${process.env.VUE_APP_SSO}${clientid}`;
            return;
          }
        }
      }
      next('/login')
    };

    return api.post(`${process.env.VUE_APP_API_URL}/check_token`, qs.stringify({
      token : store.state.token
    }))
      .then(
        () => {
          if (to.path === '/login' || toRoute[0] === 'bypass') {
            window.location.href = `${process.env.VUE_APP_CARPOOLING_URL}/#/book`;
            setTimeout(() => {
              location.reload();
            }, 2e3)
          } else {
            next();
          }
        }
      )
      .catch((error) => {
        if (error && error.apiCode === 401) {
          onTokenRejected()
          return
        }
        // A timeout or dropped connection is not a reason to throw the session
        // away, but the guard still has to finish or navigation wedges.
        next()
      })
  } else if (toRoute[0] === 'message') {
    next();
  } else if (!store.state.token && toRoute[0] === 'bypass') {
    const token = toRoute[1];
    const payload = qs.stringify({ token });
    const url = `${process.env.VUE_APP_API_URL}/check_token`;
    const onBypassRejected = () => {
      if (process.env.VUE_APP_SSO) {
        if (process.env.VUE_APP_WEB === 'yarra') {
          window.location.href = process.env.VUE_APP_SSO;
          return;
        } else {
          if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
            const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
            window.location.href = `${process.env.VUE_APP_SSO}${clientid}`;
            return;
          }
        }
      }
      next('/login')
    };

    api.post(url, payload)
      .then(() => {
          const url_load_user = `${process.env.VUE_APP_API_URL}/get_user_by_token`;
          return api.post(url_load_user, payload)
            .then((resp) => {
              const { user } = resp.data.data;
              user.token = token;
              new Promise((resolve, reject) => {
                try {
                  localStorage.setItem(`USER_DATA_${STORAGE_NAME}`, JSON.stringify({
                    token,
                    user_id: user.id,
                    user: {
                      username: user.username,
                      type: user.type,
                      clientid: user.clientid,
                    },
                    response_login: resp.data.data
                  }))
                } catch (e) {}
                try {
                  localStorage.setItem(`CLIENTID_${STORAGE_NAME}`, user.clientid);
                } catch (e) {}
                resolve();
              })
              .then(() => {
                user.sso = true;
                const current_user_data = {user, token};
                store.commit('SET_DATA', current_user_data);
                store.commit('ADD_USER_DATA', current_user_data);
              })
              .finally(() => {
                window.location.href = `${process.env.VUE_APP_CARPOOLING_URL}/#/book`;
                setTimeout(() => {
                  location.reload();
                }, 2e3)
              });
            });
      })
      .catch(onBypassRejected);
  } else if (isNull(store.state.token) && to.path !== '/login' && to.name !== 'register' && to.name !== 'reset_password') {
    if (process.env.VUE_APP_SSO) {
      if (process.env.VUE_APP_WEB === 'yarra') {
        window.location.href = process.env.VUE_APP_SSO;
        return;
      } else {
        if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
          const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
          window.location.href = `${process.env.VUE_APP_SSO}${clientid}`;
          return;
        }
      }
    }
    next('/login')
  } else if (!store.state.token && to.path === '/login') {
    if (process.env.VUE_APP_SSO) {
      let loginUrl = process.env.VUE_APP_SSO;
      if (process.env.VUE_APP_WEB === 'yarra') {
        if (store.state.logout_from_button) loginUrl = `${loginUrl}/yes`;
        window.location.href = loginUrl;
        return;
      } else if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
        const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
        window.location.href = `${loginUrl}${clientid}&relogin=1`
        return;
      }
    }
    next()
  } else {
    next()
  }
})

store.dispatch('LOAD_TOKEN')
  .then(() => {
    new Vue({
      Vuex,
      router,
      Sentry,
      store,
      vuetify,
      vSelect,
      render: h => h(App)
    }).$mount('#app')
  })
